import { Model } from 'vue-models'
import DateTime from '../types/DateTime'
import TextField from '../types/TextField'
import ConventionalShipment from './shipment'
import Device from '../device'
import ConventionalStageModel from './stage'
import UserModel from '../user'
import moment from 'moment'

export default class ConventionalTrackingRequest extends Model {
  static defaults () {
    return {
      name: 'tracking request',
      basePath: 'conventional-tracking-requests',
      computed: {
        archivable () {
          if (!this.cancellable) { return false }
          return ['new', 'pending_archiving', 'archived', 'pending_cancelling', 'cancelled'].indexOf(this.status) < 0
        },
        cancellable () {
          return ['new', 'pending_archiving', 'pending_cancelling', 'cancelled'].indexOf(this.status) < 0
        },
        milestone () { if (this.conventional_shipment.milestone) { return this.conventional_shipment.milestone } else { return '-' } },
        vessel_status () { if (this.conventional_shipment.ais_status) { return this.conventional_shipment.ais_status } else { return '-' } },
        port_of_loading () { if (this.pol && this.pol.port) { return this.pol.port.locode } else { return '-' } },
        port_of_discharge () { if (this.pod && this.pod.port) { return this.pod.port.locode } else { return '-' } },
        ata () { if (this.pod && this.pod.arrival_actual) { return moment(this.pod.arrival_actual).format('YYYY-MM-DD HH:mm') } else { return '-' } },
        eta () { if (this.pod && this.pod.arrival_planned) { return moment(this.pod.arrival_planned).format('YYYY-MM-DD HH:mm') } else { return '-' } },
        atd () { if (this.pol && this.pol.departure_actual) { return moment(this.pol.departure_actual).format('YYYY-MM-DD HH:mm') } else { return '-' } },
        etd () { if (this.pol && this.pol.departure_planned) { return moment(this.pol.departure_planned).format('YYYY-MM-DD HH:mm') } else { return '-' } },
        last_port () { if (this.conventional_shipment && this.conventional_shipment.current_stage && this.conventional_shipment.current_stage.port && this.conventional_shipment.current_stage.port.locode) { return this.conventional_shipment.current_stage.port.locode } else { return '-' } },
        next_port () { if (this.conventional_shipment && this.conventional_shipment.current_stage && this.conventional_shipment.current_stage.next_stage && this.conventional_shipment.current_stage.next_stage.port && this.conventional_shipment.current_stage.next_stage.port.locode) { return this.conventional_shipment.current_stage.next_stage.port.locode } else { return '-' } },
        atd_last_port () {
          if (this.conventional_shipment && this.conventional_shipment.current_stage && this.conventional_shipment.current_stage.departure_actual) {
            return moment(this.conventional_shipment.current_stage.departure_actual).format('YYYY-MM-DD HH:mm')
          } else {
            return '-'
          }
        },
        eta_next_port () {
          if (this.conventional_shipment && this.conventional_shipment.current_stage && this.conventional_shipment.current_stage.next_stage) {
            return moment(this.conventional_shipment.current_stage.next_stage.arrival_planned).format('YYYY-MM-DD HH:mm')
          } else {
            return '-'
          }
        },
        vessel_name () {
          if (this.conventional_shipment && this.conventional_shipment.vessel) {
            return this.conventional_shipment.vessel.name
          } else {
            return '-'
          }
        }
      }
    }
  }
  static schema () {
    return {
      id: { type: Number },
      vessel_imo: { type: TextField },
      pod: { type: ConventionalStageModel },
      pol: { type: ConventionalStageModel },
      status: { type: TextField },
      conventional_shipment: { type: ConventionalShipment },
      last_update: { type: DateTime },
      created_at: { type: DateTime },
      modified_at: { type: DateTime },
      user: { type: UserModel },
      devices: { type: Array, items: { type: Device } }
    }
  }
  static STATUS = {
    invalid: 'Invalid',
    new: 'New',
    ongoing: 'On going',
    pending_archiving: 'Pending of archiving',
    archived: 'Archived',
    pending_cancelling: 'Pending of cancelling',
    cancelled: 'Cancelled'
  }
  static STATUS_FILTER = {
    invalid: 'Invalid',
    new: 'New',
    ongoing: 'On going',
    archived: 'Archived',
    cancelled: 'Cancelled'
  }
  static SHIPMENTS_HEALTH = {
    ontrack: 'On track',
    delayed: 'Later than expected',
    alerted: 'Attention required'
  }
}



// WEBPACK FOOTER //
// ./src/models/conventional/trackingRequest.js